import { useQuery } from "react-query";
import LoadingApiClient from "api/LoadingApiClient";

export function useRegionLoading(regionId) {
    return useQuery(["RegionLoading", { regionId }], () =>
        LoadingApiClient.getRegionLoading(regionId),
    );
}
